// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"fb078ffc","6744":"10d42acc"}[chunkId] + ".chunk.css";
};